<template>
    <button class="button-outline">{{ text }}</button>
</template>
<script>
export default {
    props: {
        text : {
            type : String,
            required : true
        }
    }
}
</script>
<style lang="scss" scoped>
    .button-outline{
        letter-spacing: 2px;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 11px;
        color: #30353a;
        border: none;
        border-bottom: 1px solid #a0a0a0;
        padding-bottom: 2px;
        background-color: transparent;
        cursor: pointer;
        outline: none;
    }
</style>
